module.exports = __webpack_public_path__ + "static/media/providence-11.b85f3930.jpg";